{
    "Domain": "Domaine :",
    "EmailServerConnectivity": "Connectivité du serveur de courrier électronique",
    "ServerIpAddress": "Adresse IP du serveur :",
    "TcpPort": "Port TCP :",
    "CommunicationActive": "Communication active :",
    "FromAddressEmail": "Adresse de départ (courriel) :",
    "FromAddressName": "De l'adresse (nom) :",
    "CompanyName": "Nom de la société :",
    "UseAuthentication": "Utiliser l'authentification :",
    "AuthenticationSettings": "Paramètres d'authentification",
    "DomainProfile_ButtonHelpLabel": "De l'aide ?",
    "DomainProfile_ButtonSubmitLabel": "OK",
    "DomainProfile_ButtonCancelLabel": "Annuler",
    "DomainProfile_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues lors de la fermeture.",
    "DomainProfile_PromptConfirm": "Oui",
    "DomainProfile_PromptCancel": "Annuler",
    "DomainProfile_Username": "Nom d'utilisateur :",
    "DomainProfile_Password": "Mot de passe :",
    "DomainProfile_PasswordPlaceholder": "------",
    "NAME": "DomainProfile",
    "CustomDownloadLinks": "Liens de téléchargement personnalisés",
    "MSTeamsAppDownloadLinkURLName": "URL de téléchargement de l'application MS Teams :",
    "CXIClientDownloadLinkWindowsUrlName": "URL du client CXI (Windows) :",
    "CXIClientDownloadLinkMacUrlName": "URL du client CXI (Mac) :",
    "SearchAndCallDownloadLinkURLName": "Rechercher et appeler l'URL :",
    "AccessCodes": "Codes d'accès",
    "CXIAccessCode": "Code d'accès CXI :"
}